// eslint-disable-next-line import/extensions
import IonNotification from './src/main.js';

export default IonNotification;
